<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense color="secondary" elevation="1" rounded>
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & Inventory'}, {text: 'Measure Unit'} ,{text: 'Display Measure Unit'}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Measure Unit
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-pencil" tooltip="Edit" @click="navigateToEdit" v-if="hasPermission(perm.measure_unit.update)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" v-if="hasPermission(perm.measure_unit.index)"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <MeasureUnit :value="data" v-if="data"/>
                    <v-row class="pa-2" v-else>
                        <v-col>    
                            <v-skeleton-loader
                                type="table-cell, divider, table-cell"
                            ></v-skeleton-loader>
                        </v-col>
                        <v-col>    
                            <v-skeleton-loader
                                type="table-cell,divider,table-cell"
                            ></v-skeleton-loader>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import MeasureUnit from './../../components/warehouse/MeasureUnit'
import PIconBtn from './../../components/common/PIconBtn.vue'
import PAlert from './../../components/common/PAlert';
import { mapActions, mapGetters } from 'vuex';
import permissions from './../../data/permissions';
export default {
    name: "MeasureUnitDisplayView",
    components: {
        PAlert,
        PIconBtn,
        MeasureUnit
    },
    data() {
        return {
            data: null,
            id: null,
            alert: {
                value: false,
            },
            loading: false,
            perm : permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            findByID: "warehouse/measureUnit/findByID",
            snackbar: "ui/snackbar/show",
        }),
        navigateToEdit() {
            this.$router.push({name: "MeasureUnitEdit", params: {id: this.id } })
        }, 
        getMeasureUnit() {
            this.loading = true
            this.findByID(this.id).then(response => {
            this.data = response.data 
            }).catch(error => {
            let message = error.response ? error.response.data.message : error
            this.snackbar({color: 'error', text: message })
            console.log(error)
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({name: "MeasureUnitList"})
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getMeasureUnit()
    },
    beforeRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getMeasureUnit();
        next()
    },
}
</script>

<style>

</style>